/**
 * Popover/index.js
 * desc: popover element
 * note: uses radix-ui/react-popover component
 */
'use strict';

import * as PopoverRadix from '@radix-ui/react-popover';
import './styles.css';
import { classNames } from '../../utilities';

const ARROW_HEIGHT = 6;
const ARROW_WIDTH = 14;

const Popover = ({ align="start", alignOffset, arrow, asChild, children, content, contentClassname, collisionPadding, modal=false, open, onOpenChange, onInteractOutside, onOpenAutoFocus, onCloseAutoFocus, side="top", sideOffset=5, triggerClassname }) => (
    <PopoverRadix.Root modal={ modal } open={ open } onOpenChange={ onOpenChange }>

        <PopoverRadix.Trigger className={ classNames("component-popover-trigger", triggerClassname) } asChild={ asChild }>
            { children }
        </PopoverRadix.Trigger>

        <PopoverRadix.Portal>
            <PopoverRadix.Content
                className={ classNames("component-popover-content", contentClassname) }
                sideOffset={ sideOffset }
                side={ side }
                alignOffset={ alignOffset }
                align={ align }
                onOpenAutoFocus={ onOpenAutoFocus }
                onCloseAutoFocus={ onCloseAutoFocus }
                onInteractOutside={ onInteractOutside }
                collisionPadding={ collisionPadding }
            >
                { content }
                { arrow && <PopoverRadix.Arrow className="component-popover-arrow" width= { ARROW_WIDTH } height={ ARROW_HEIGHT } /> }
            </PopoverRadix.Content>
        </PopoverRadix.Portal>

    </PopoverRadix.Root>
);


export default Popover;
